<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }" v-loading="showPage">
    <div class="flex items-center">
      <el-button size="small" type="primary" @click="cancel" class="mr-10px">
        {{ $t('返回') }}
      </el-button>
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">稿费计算信息</span>
    </div>
    <div class="w-full mt-20px">
      <el-row :gutter="24">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
          <el-col :span="8">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" disabled class="!w-310px"></el-input>
              <el-button type="primary" class="ml-10px" @click="viewModel()">查看</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布人" prop="publisherName">
              <el-input v-model="ruleForm.publisherName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="文字作者"
              prop="textAuthor"
              v-if="columnType === 1 || columnType === 2"
            >
              <el-select
                size="small"
                v-model="ruleForm.textAuthor"
                multiple
                collapse-tags
                disabled
                class="w-full"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="图片作者" prop="imageAuthor" v-if="columnType === 2">
              <el-select
                size="small"
                v-model="ruleForm.imageAuthor"
                multiple
                class="w-full"
                collapse-tags
                disabled
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="视频作者" prop="videoAuthor" v-if="columnType === 3">
              <el-select
                size="small"
                v-model="ruleForm.videoAuthor"
                multiple
                class="w-full"
                collapse-tags
                disabled
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布时间" prop="publishTime">
              <el-date-picker
                v-model="ruleForm.publishTime"
                type="datetime"
                placeholder="选择日期时间"
                style="width: 100%;"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否计算稿费" prop="isCompute">
              <el-radio-group
                v-model="ruleForm.isCompute"
                @input="changeIsCompute"
                :disabled="type === 'view'"
              >
                <el-radio :label="true">计算</el-radio>
                <el-radio :label="false">不计算</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="稿费作者" prop="authors">
              <div class="flex">
                <el-select
                  size="small"
                  v-model="ruleForm.authors"
                  multiple
                  placeholder="请选择"
                  class="flex-1"
                  collapse-tags
                  disabled
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  :disabled="type === 'view'"
                  type="primary"
                  class="ml-10px"
                  @click="openAddUser('authors')"
                  >选择人员</el-button
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门" prop="deptSource">
              <el-tooltip effect="dark" :content="orgName" placement="top">
                <el-select
                  v-model="ruleForm.deptSource"
                  placeholder="请选择"
                  class="w-full"
                  multiple
                  collapse-tags
                  :disabled="true"
                >
                  <el-option
                    v-for="item in orgList"
                    :key="item.id"
                    :label="item.displayName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="稿件类别" prop="royaltiesCategoryId" v-if="ruleForm.isCompute">
              <el-select
                v-model="ruleForm.royaltiesCategoryId"
                placeholder="请选择"
                class="w-full"
                @change="getRoyaltiesList"
                :disabled="type === 'view'"
              >
                <el-option
                  v-for="item in royaltiesCategory"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="稿件类型" prop="royaltiesTypeId" v-if="ruleForm.isCompute">
              <el-select
                v-model="ruleForm.royaltiesTypeId"
                placeholder="请选择"
                class="w-full"
                @change="getRoyaltiesList"
                :disabled="type === 'view'"
              >
                <el-option
                  v-for="item in royaltiesType"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="稿件级别" prop="royaltiesLevel" v-if="ruleForm.isCompute">
              <el-checkbox-group
                v-model="ruleForm.royaltiesLevel"
                @change="getRoyaltiesList"
                :disabled="type === 'view'"
              >
                <el-checkbox
                  v-for="(item, index) in royaltiesLeavel"
                  :key="index"
                  :label="item.id"
                  >{{ item.displayName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="是否配照片"
              prop="isWithImage"
              v-if="ruleForm.isCompute && showImage"
            >
              <el-radio-group
                v-model="ruleForm.isWithImage"
                @input="getRoyaltiesList"
                :disabled="type === 'view'"
              >
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="稿费总额" prop="count" v-if="ruleForm.isCompute">
              <el-input v-model="ruleForm.count" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="flex items-center my-20px" v-if="ruleForm.isCompute">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">稿费统计</span>
    </div>
    <div v-if="ruleForm.isCompute">
      <el-table
        ref="singleTable"
        :data="royaltiesCountList"
        highlight-current-row
        style="width: 100%"
        border
      >
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column property="authorName" label="作者名称"></el-table-column>
        <el-table-column property="royaltiesCount" label="分配稿费">
          <template slot-scope="scope">
            <div>
              {{ scope.row[scope.column.property].toFixed(2) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex items-center my-20px" v-if="ruleForm.isCompute">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">宣传任务统计</span>
    </div>
    <div class="mt-20px" v-if="ruleForm.isCompute">
      <el-table
        ref="singleTable"
        :data="taskCountList"
        highlight-current-row
        style="width: 100%"
        border
      >
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column property="deptName" label="部门名称"></el-table-column>
        <el-table-column property="royaltiesLevelName" label="稿件级别"></el-table-column>
        <el-table-column property="taskCount" label="完成稿件">
          <template slot-scope="scope">
            <div>
              {{ scope.row[scope.column.property].toFixed(2) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center mt-20px pb-20px" v-if="type === 'edit'">
      <el-button type="primary" size="small" @click="save('ruleForm')" :loading="saveLoading"
        >保存</el-button
      >
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
    <wiz-tree-select
      :visible.sync="dialogVisible"
      :treeData="orgUserTree"
      :treeExpandedKeys="treeExpandedKeys"
      treeCheckField="isActive"
      @save="getSelectUser"
      :defaultSelectKeys="defaultSelectKeys"
      title="添加人员"
      treeNodeKey="key"
      :disabled="type === 'view'"
    />
  </el-card>
</template>

<script>
import { RoyaltiesRecordApi, ColumApi } from '@wiz-api/workbench'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { OrganizationApi } from '@wiz-api/abp-identity'
import { informationPublishMap } from '@/modules/portal-management/js/config'
import { treeToOneArray } from '@/assets/js/Common'
import dayjs from 'dayjs'

const columApi = new ColumApi()
const dataCategoryApi = new DataCategoryApi()
const royaltiesRecordApi = new RoyaltiesRecordApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const organizationApi = new OrganizationApi()
const columnOutSourceType = informationPublishMap.columnSource.columnFromThird // 外网栏目
export default {
  data() {
    return {
      ruleForm: {
        title: '',
        authors: [],
        textAuthor: [],
        imageAuthor: [],
        videoAuthor: [],
        publisherName: '',
        publishTime: '',
        isCompute: true,
        royaltiesCategoryId: '',
        royaltiesTypeId: '',
        royaltiesLevel: [],
        isWithImage: false,
        count: '',
      },
      rules: {
        authors: [{ required: true, message: '请选择作者', trigger: 'change' }],
        isCompute: [{ required: true, message: '请选择是否计算稿费', trigger: 'change' }],
        royaltiesLevel: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个稿件级别',
            trigger: 'change',
          },
        ],
        isWithImage: [{ required: true, message: '请选择是否配照片', trigger: 'change' }],
      },
      options: [],
      authorList: [],
      royaltiesCategory: [],
      royaltiesType: [],
      royaltiesLeavel: [],
      royaltiesCountList: [],
      taskCountList: [],
      saveLoading: false,
      showImage: false,
      showPage: false,
      currentUserField: '',
      userList: [],
      orgUserTree: [],
      dialogVisible: false,
      defaultSelectKeys: [],
      treeExpandedKeys: [],
      columnType: '',
      orgList: [],
      orgName: '',
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    type() {
      return this.$route.query.type
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  async mounted() {
    await this.dataCategoryApi()
    await this.getOrgUserTree()
    await this.getOrgData()
    await this.getPersonList()
  },
  methods: {
    async getColumnType() {
      const [err, res] = await columApi.getColumnDetail(this.ruleForm.columnId)
      if (!err && res) {
        this.columnType = res.type
      }
    },
    async dataCategoryApi() {
      const param = {
        code: 'RoyaltiesCategory',
        includeDetails: true,
      }
      const [err, res] = await dataCategoryApi.getByCode(param)
      if (!err && res) {
        this.royaltiesCategory = res.dataItems
      }

      const params = {
        code: 'RoyaltiesType',
        includeDetails: true,
      }
      const [errType, resType] = await dataCategoryApi.getByCode(params)
      if (!errType && resType) {
        this.royaltiesType = resType.dataItems
      }

      const paramresLeavel = {
        code: 'RoyaltiesLevel',
        includeDetails: true,
      }
      const [errLeavel, resLeavel] = await dataCategoryApi.getByCode(paramresLeavel)
      if (!errLeavel && resLeavel) {
        this.royaltiesLeavel = resLeavel.dataItems
      }
    },
    async getPersonList() {
      this.showPage = true
      const [err, res] = await royaltiesRecordApi.getGetRoyaltiesRecord(this.id)
      if (!err && res) {
        this.ruleForm = {
          ...res,
          deptSource: res.deptSource ? JSON.parse(res.deptSource) : [],
          textAuthor: res.textAuthor ? res.textAuthor.split(',') : [],
          imageAuthor: res.imageAuthor ? res.imageAuthor.split(',') : [],
          videoAuthor: res.videoAuthor ? res.videoAuthor.split(',') : [],
        }
        this.orgName = _.map(this.ruleForm.deptSource, (item) => {
          const org = _.find(this.orgList, { id: item })
          if (org) {
            return org.displayName
          }
          return ''
        }).join(',')
        this.ruleForm.isWithImage = res.isWithImage !== null ? res.isWithImage : false
        this.ruleForm.authors = res.authors ? JSON.parse(res.authors) : []
        this.ruleForm.royaltiesLevel =
          res.royaltiesLevel !== null ? JSON.parse(res.royaltiesLevel) : []
        if (res.status === 2) {
          this.royaltiesCountList = res.royaltiesCount
          this.taskCountList = res.taskCount
        }
        res.status === 1 ? (this.ruleForm.isCompute = false) : (this.ruleForm.isCompute = true)
        await this.getUserList()
        this.getRoyaltiesList()
        this.getColumnType()
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.clearValidate() // 清除新增表单验证
        })
      }
      this.showPage = false
    },
    async getUserList() {
      const userIdList = [
        ...this.ruleForm.authors,
        ...this.ruleForm.videoAuthor,
        ...this.ruleForm.textAuthor,
        ...this.ruleForm.imageAuthor,
      ]
      if (userIdList.length === 0) return
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        userIdList: _.filter(userIdList, (item) => {
          const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
          return uuidPattern.test(item)
        }),
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && res) {
        this.userList = res.items
      }
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err) {
        this.orgList = treeToOneArray(res.items, 'children')
      }
    },
    async getRoyaltiesList() {
      if (!this.ruleForm.authors) return
      if (
        this.ruleForm.authors.length === 0 ||
        this.ruleForm.royaltiesLevel.length === 0 ||
        this.ruleForm.royaltiesTypeId === null ||
        this.ruleForm.royaltiesCategoryId === null ||
        this.ruleForm.isWithImage === null
      ) {
        return
      }
      const [err, res] = await royaltiesRecordApi.royaltiesCompute({
        body: {
          royaltiesCategoryId: this.ruleForm.royaltiesCategoryId,
          royaltiesTypeId: this.ruleForm.royaltiesTypeId,
          royaltiesLevel: JSON.stringify(this.ruleForm.royaltiesLevel),
          isWithImage: this.ruleForm.isWithImage,
          authors: JSON.stringify(this.ruleForm.authors),
          deptSource: JSON.stringify(this.ruleForm.deptSource),
        },
      })
      if (!err && res) {
        this.ruleForm.count = 0
        this.showImage = res.isImage
        this.royaltiesCountList = res.royaltiesCount
        _.some(res.royaltiesCount, (item) => {
          this.ruleForm.count += item.royaltiesCount
        })
        this.ruleForm.count = this.ruleForm.count.toFixed(2)
        this.taskCountList = res.taskCount
      }
    },
    async viewModel() {
      const [err, res] = await columApi.getColumnDetail(this.ruleForm.columnId)
      if (!err && res) {
        if (res.source === columnOutSourceType) {
          window.open(res.externalLink)
        } else {
          if (window.__POWERED_BY_QIANKUN__) {
            const baseUrl = _.get(Wiz, 'globalSettings.globalConfig.saasPage')
            if (!baseUrl) {
              this.$message.warning('缺少saasPage配置')
              return
            }
            window.open(
              `${baseUrl}/portal/ColumnDetail?token=${localStorage.getItem('authorization')}&id=${
                row.id
              }&type=${this.previewData.type}`
            )
            return
          }
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/portal/ColumnDetail?id=${this.ruleForm.columnTableId}&type=${res.type}`
          )
        }
      }
    },
    changeIsCompute(val) {
      if (val === false) {
        this.ruleForm.count = 0
        this.ruleForm.royaltiesTypeId = ''
        this.ruleForm.royaltiesCategoryId = ''
        this.ruleForm.isWithImage = false
        this.ruleForm.royaltiesLevel = []
        this.royaltiesCountList = []
        this.taskCountList = []
      }
    },
    async save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const [err, res] = await royaltiesRecordApi.updateRoyaltiesRecord({
            body: {
              id: this.ruleForm.id,
              columnId: this.ruleForm.columnId,
              title: this.ruleForm.title,
              authors: JSON.stringify(this.ruleForm.authors),
              publisherId: this.ruleForm.publisherId,
              publishTime: dayjs(this.ruleForm.publishTime).format('YYYY-MM-DD HH:mm:ss'),
              isCompute: this.ruleForm.isCompute,
              royaltiesCategoryId: this.ruleForm.royaltiesCategoryId || null,
              royaltiesTypeId: this.ruleForm.royaltiesTypeId || null,
              royaltiesLevel: JSON.stringify(this.ruleForm.royaltiesLevel),
              isWithImage: this.ruleForm.isWithImage,
              status: this.ruleForm.status,
              textAuthor: this.ruleForm.textAuthor.join(','),
              imageAuthor: this.ruleForm.imageAuthor.join(','),
              videoAuthor: this.ruleForm.videoAuthor.join(','),
              deptSource: this.ruleForm.deptSource.length
                ? JSON.stringify(this.ruleForm.deptSource)
                : null,
            },
          })
          if (!err && res) {
            this.$message.success('保存成功')
            this.cancel()
          }
        }
      })
    },
    cancel() {
      this.ruleForm = this.$options.data().ruleForm
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/royalties-compute`,
      })
    },
    openAddUser(field) {
      this.defaultSelectKeys = _.cloneDeep(this.ruleForm[field])
      this.currentUserField = field
      this.dialogVisible = true
    },
    getSelectUser(data) {
      this.$refs.ruleForm.clearValidate(this.currentUserField)
      this.userList = _.uniqBy([...this.userList, ...data], 'id')
      this.ruleForm[this.currentUserField] = _.map(data, (item) => {
        return item.id
      })
      this.getRoyaltiesList()
    },
    async getOrgUserTree() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({})
      if (!err) {
        this.orgUserTree = this.processedTreeData(res)
        if (this.orgUserTree.length) {
          this.treeExpandedKeys = [this.orgUserTree[0].id]
        }
      }
    },
    processedTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = _.cloneDeep(item)
        cloneTreeItem.label = item.organizationUnitName
        cloneTreeItem.id = item.organizationUnitId
        cloneTreeItem.key = item.organizationUnitId
        let hanldeChildren = []
        if (item.childen && item.childen.length) {
          hanldeChildren = this.processedTreeData(item.childen)
        }
        const userList = _.map(item.userList, (user) => {
          return {
            ...user,
            key: `${item.organizationUnitId}-${user.id}`,
            label: user.name,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...hanldeChildren, ...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
  },
}
</script>

<style lang="scss" scoped></style>
